import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import { env } from '@/lib/env'

import { queryClient } from '@/api/query-client'
import huCommon from '@/lib/i18n/locales/hu/common.json'
import huErrors from '@/lib/i18n/locales/hu/errors.json'
import enCommon from '@/lib/i18n/locales/en/common.json'
import enErrors from '@/lib/i18n/locales/en/errors.json'

// import { apiBackend } from './apiBackend'

export const SUPPORTED_LANGUAGES = ['hu', 'en'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: SupportedLanguage = 'hu'
export const DEFAULT_NAMESPACE = 'common'

void i18n
  // .use(apiBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      hu: {
        common: huCommon,
        errors: huErrors,
      },
      en: {
        common: enCommon,
        errors: enErrors,
      },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: DEFAULT_NAMESPACE,
    ns: [DEFAULT_NAMESPACE, 'errors'],
    debug: env.isDevelopment,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'corvinus-language',
      caches: ['localStorage'],
    },
    returnNull: false,
  })

i18n.on('languageChanged', () => {
  void queryClient.invalidateQueries()
})

export default i18n
